import React, { Fragment} from "react";
import HTMLFlipBook from "react-pageflip";
import ProductosVariables from "../cart/ProductosVariables";
import CarritoEnProductos from "../cart/CarritoEnProductos";
import MostrarVideos from "../MostrarVideos"

import "./flipbook.css";
import { Icon } from 'semantic-ui-react';

const PageCover = React.forwardRef((props, ref) => {
  let contenido = props.contenido
  return (
    <div className={"page page-cover " + contenido} ref={ref} data-density="hard">
      <div className="page-content">
        
      </div>
    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  let number = props.number
  return <div ref={ref} className={"Page"+number+" page"}>
       <div className="page-content">{props.children}</div> 
  </div>;
});




export default class MyBook extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      totalPage: 0,
      contro: true
    };
  }
  mover = () => {
    let modifier = 5;
            const block = document.getElementById("block");
            let moveDown = document.addEventListener('keydown', (event) => {
                const{ style } = block;
                switch (event.key){
                    case 'ArrowUp': style.top = `${parseInt(style.top) - modifier}px`; break
                    case 'ArrowDown': style.top = `${parseInt(style.top) + modifier}px`; break
                    case 'ArrowLeft': style.left = `${parseInt(style.left) - modifier}px`; break
                    case 'ArrowRight': style.left = `${parseInt(style.left) + modifier}px`; break
                }
            })
  }

  bloquearClick = () => {
    this.flipBook.getPageFlip();
  };
  nextButtonClick = () => {
    this.flipBook.getPageFlip().flipNext();
  };

  prevButtonClick = () => {
    this.flipBook.getPageFlip().flipPrev();
  };

  onPage = (e) => {
    this.setState({
      page: e.data,
    });
  };
  
  cambiar = () =>{
  
    this.state.contro = false


  }

  componentDidMount() {
    this.setState({
      totalPage: this.flipBook.getPageFlip().getPageCount(),
    });
  }

  render() {

    return (
      <Fragment>
        <div className="row">
        <div className="col-12">
          <HTMLFlipBook
            width={535}
            height={740}
            size="stretch"
            minWidth={370}
            maxWidth={535}
            minHeight={518}
            maxHeight={740}
            maxShadowOpacity={0.5}
            showCover={true}
            mobileScrollSupport={true}
            onFlip={this.onPage}
            clickEventForward={true}
            useMouseEvents={false}
            usePortrait={true}
            onChangeOrientation={this.onChangeOrientation}
            onChangeState={this.onChangeState}
            ref={(el) => (this.flipBook = el)}
          >
            
              <PageCover contenido={"inicio"}> </PageCover>

              <Page number={1}></Page>

              <Page number={2}></Page>

              <Page number={3}>
              </Page>

              <Page number={4}>
                <CarritoEnProductos idProducto={'72157'} left={"418px"} top={"295px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={5}></Page>

              <Page number={6}>
              <ProductosVariables idProducto={'72626'} left={"58px"} top={"200px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={7}>
              <ProductosVariables idProducto={'59748'} left={"400px"} top={"552px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={8}> 
              <ProductosVariables idProducto={'69692'} left={"375px"} top={"515px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={9}>
              </Page>

              <Page number={10}>
              </Page>

              <Page number={11}>
              <CarritoEnProductos idProducto={'72056'} left={"350px"} top={"90px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={12}>
              <CarritoEnProductos idProducto={'72057'} left={"208px"} top={"300px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={13}>
              <CarritoEnProductos idProducto={'72058'} left={"310px"} top={"90px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={14}>
              <CarritoEnProductos idProducto={'72059'} left={"340px"} top={"285px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={15}>
              <ProductosVariables idProducto={'47699'} left={"410px"} top={"175px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'44737'} left={"20px"} top={"535px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'44751'} left={"140px"} top={"535px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'44761'} left={"260px"} top={"535px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'564'} left={"385px"} top={"535px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={16}></Page>

              <Page number={17}>
              </Page>

              <Page number={18}>
              <CarritoEnProductos idProducto={'501'} left={"25px"} top={"555px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'6977'} left={"110px"} top={"555px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'5634'} left={"200px"} top={"555px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'500'} left={"310px"} top={"555px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'504'} left={"420px"} top={"555px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>
  
              <Page number={19}>
              <CarritoEnProductos idProducto={'7879'} left={"125px"} top={"575px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'494'} left={"225px"} top={"575px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'496'} left={"315px"} top={"575px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={20}>
              <CarritoEnProductos idProducto={'485'} left={"28px"} top={"580px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2377'} left={"138px"} top={"580px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'59131'} left={"240px"} top={"580px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'487'} left={"325px"} top={"580px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={21}>
              <CarritoEnProductos idProducto={'474'} left={"50px"} top={"562px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'478'} left={"170px"} top={"562px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'480'} left={"285px"} top={"562px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'476'} left={"405px"} top={"562px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={22}>
              </Page>

              <Page number={23}> 
              <CarritoEnProductos idProducto={'66196'} left={"230px"} top={"450px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'66197'} left={"395px"} top={"450px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'66198'} left={"230px"} top={"578px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'66199'} left={"395px"} top={"578px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={24}>
              <CarritoEnProductos idProducto={'6977'} left={"270px"} top={"400px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'30139'} left={"270px"} top={"505px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'44363'} left={"270px"} top={"590px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={25}>
              <CarritoEnProductos idProducto={'7194'} left={"360px"} top={"170px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'7190'} left={"360px"} top={"240px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'7196'} left={"115px"} top={"505px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'7199'} left={"115px"} top={"575px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={26}>
              <CarritoEnProductos idProducto={'491'} left={"110px"} top={"215px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'8517'} left={"70px"} top={"480px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={27}> 
              <CarritoEnProductos idProducto={'699'} left={"380px"} top={"40px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'33547'} left={"70px"} top={"425px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'706'} left={"340px"} top={"545px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={28}>
              <CarritoEnProductos idProducto={'15352'} left={"355px"} top={"55px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={29}>
              </Page>

              <Page number={30}>
              <CarritoEnProductos idProducto={'9205'} left={"135px"} top={"85px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'503'} left={"60px"} top={"450px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'710'} left={"300px"} top={"450px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'708'} left={"420px"} top={"450px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'9206'} left={"180px"} top={"530px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={31}>
              <CarritoEnProductos idProducto={'709'} left={"395px"} top={"1px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'38413'} left={"95px"} top={"535px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={32}>
              <CarritoEnProductos idProducto={'502'} left={"295px"} top={"5px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'716'} left={"340px"} top={"468px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={33}>
              </Page>

              <Page number={34}>
              </Page>

              <Page number={35}>
              <CarritoEnProductos idProducto={'3941'} left={"45px"} top={"565px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'5869'} left={"282px"} top={"575px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={36}>
              <ProductosVariables idProducto={'8971'} left={"188px"} top={"5px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'47587'} left={"40px"} top={"520px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={37}>
              <ProductosVariables idProducto={'38230'} left={"208px"} top={"145px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2464'} left={"380px"} top={"165px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'2412'} left={"135px"} top={"505px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={38}>
              <ProductosVariables idProducto={'69038'} left={"45px"} top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={39}>
              </Page>

              <Page number={40}>
              <CarritoEnProductos idProducto={'2375'} left={"370px"} top={"30px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'38317'} left={"232px"} top={"490px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={41}>
              <CarritoEnProductos idProducto={'5054'} left={"385px"} top={"80px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2634'} left={"345px"} top={"215px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'2327'} left={"355px"} top={"525px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={42}>
              <CarritoEnProductos idProducto={'2630'} left={"415px"} top={"5px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={43}>
              <CarritoEnProductos idProducto={'5361'} left={"380px"} top={"250px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2633'} left={"210px"} top={"550px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'18620'} left={"350px"} top={"550px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={44}>
              <CarritoEnProductos idProducto={'49920'} left={"388px"} top={"45px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'711'} left={"102px"} top={"495px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={45}>
              <CarritoEnProductos idProducto={'2559'} left={"330px"} top={"170px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'4199'} left={"310px"} top={"325px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'38869'} left={"435px"} top={"500px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2560'} left={"70px"} top={"585px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2561'} left={"130px"} top={"650px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={46}>
              <CarritoEnProductos idProducto={'2522'} left={"410px"} top={"230px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={47}>
              </Page>

              <Page number={48}>
              <ProductosVariables idProducto={'2552'} left={"35px"} top={"95px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'43175'} left={"145px"} top={"440px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={49}>
              </Page>

              <Page number={50}>
              <ProductosVariables idProducto={'8965'} left={"45px"} top={"90px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={51}>
              <CarritoEnProductos idProducto={'49924'} left={"280px"} top={"70px"} width={"35px"} height={"35px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'1896'} left={"280px"} top={"110px"} width={"35px"} height={"35px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'1908'} left={"280px"} top={"150px"} width={"35px"} height={"35px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'1904'} left={"280px"} top={"190px"} width={"35px"} height={"35px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={52}>
              <ProductosVariables idProducto={'7548'} left={"340px"}   top={"210px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'10242'} left={"140px"}   top={"440px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'8036'} left={"400px"}   top={"460px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'1066'} left={"20px"}   top={"510px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={53}>
              <ProductosVariables idProducto={'6959'} left={"145px"}  top={"8px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'8968'} left={"145px"}  top={"650px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={54}>
              <CarritoEnProductos idProducto={'1919'} left={"35px"}   top={"460px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'5691'} left={"330px"}   top={"605px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={55}>                
              <ProductosVariables idProducto={'32441'}  left={"400px"} top={"8px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={56}>
              </Page>

              <Page number={57}>
              <CarritoEnProductos idProducto={'56799'} left={"72px"} top={"585px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'56801'} left={"270px"} top={"585px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={58}>
              <CarritoEnProductos idProducto={'38412'} left={"380px"} top={"50px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'872'} left={"35px"} top={"520px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'887'} left={"35px"} top={"620px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={59}>
              <CarritoEnProductos idProducto={'895'} left={"50px"} top={"335px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'898'} left={"210px"} top={"335px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'901'} left={"350px"} top={"335px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2483'} left={"65px"} top={"565px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={60}>
              <CarritoEnProductos idProducto={'5510'} left={"375px"} top={"125px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'881'} left={"360px"} top={"575px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={61}>
              </Page>

              <Page number={62}>
              <CarritoEnProductos idProducto={'5512'} left={"40px"}  top={"510px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={63}>
              <CarritoEnProductos idProducto={'33799'} left={"160px"}  top={"70px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />                
              <CarritoEnProductos idProducto={'2407'} left={"50px"}  top={"165px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />                
              <CarritoEnProductos idProducto={'2405'} left={"270px"}  top={"560px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'7935'} left={"70px"}  top={"625px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={64}>
              </Page>

              <Page number={65}></Page>

              <Page number={66}>
              </Page>

              <Page number={67}></Page>
{/* VOY EN ESTA PAGINA */}

          
            </HTMLFlipBook>
            </div>
         
        </div>
        <div id="slide">
          <div className="flechas" id="retroceder"  onClick={this.prevButtonClick}> <Icon name='angle left'  size='huge' /></div>
          <div className="flechas" id="avanzar"   onClick={this.nextButtonClick}><Icon name='angle right'  size='huge' />  </div>
        </div>

      </Fragment>
    );
  }
}

